import axios from '../utils/axios';

/**
 * 保存草稿箱
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getInvestorInfoDraftSave(data, au) {
  return axios('/ttd-fund-user/investorInfoDrafts/editInvestorInfoDraft', data, au);
}
/**
 * 产品买产品投资者信息获取
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getInvestorProductInfo(data, au) {
  return axios('/ttd-fund-user/productInvenstement/getProductInvenstement', data, au);
}
